module.exports = __webpack_public_path__ + "static/media/Logo-PNG-Blau-72.98446df7.png";